import React, { useEffect, useState } from 'react';
import { Send, CheckCircle2, Eye, PenLine, Settings2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { fmtDate } from './crmConstants';
import { EmailComposeDialog } from './EmailComposeDialog';
import { EmailTemplatesDialog } from './EmailTemplatesDialog';

const stripHtml = (h = '') => h.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

export const LeadEmails = ({ api, lead, showToast, onChanged, isAdmin }) => {
  const [templates, setTemplates] = useState([]);
  const [compose, setCompose] = useState(null);
  const [manage, setManage] = useState(false);
  const load = () => api.get('/admin/email-templates').then(setTemplates).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-3" data-testid="lead-emails">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-[11px] text-slate-500">Apri l'anteprima per leggere e ritoccare il testo prima di inviarlo.</p>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => setCompose({ template: null })} className="bg-slate-700 hover:bg-slate-600" data-testid="email-free-btn"><PenLine className="w-4 h-4 mr-1" /> Email libera</Button>
          {isAdmin && <Button size="sm" onClick={() => setManage(true)} className="bg-slate-700 hover:bg-slate-600" data-testid="email-manage-btn"><Settings2 className="w-4 h-4 mr-1" /> Gestisci template</Button>}
        </div>
      </div>
      {templates.map((tpl) => {
        const done = lead.actions_done?.[`email_${tpl.key}`];
        return (
          <div key={tpl.id} className={`p-3 rounded-xl border ${done ? 'border-emerald-500/40 bg-emerald-500/5' : 'border-slate-700 bg-slate-800/50'}`} data-testid={`email-tpl-${tpl.key}`}>
            <div className="flex items-center gap-3">
              {done ? <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" /> : <Send className="w-5 h-5 text-slate-500 flex-shrink-0" />}
              <div className="flex-1 min-w-0">
                <p className="text-sm text-white font-medium">{tpl.name}</p>
                <p className="text-[11px] text-slate-400" data-testid={`email-tpl-status-${tpl.key}`}>
                  {done ? `Inviata ${fmtDate(done.at)}${done.by ? ` da ${done.by}` : ''}` : 'Non ancora inviata'}
                </p>
              </div>
              <Button size="sm" onClick={() => setCompose({ template: tpl })} disabled={!lead.email} className={done ? 'bg-slate-700 hover:bg-slate-600' : 'bg-blue-600 hover:bg-blue-500'} data-testid={`lead-template-${tpl.key}`}>
                <Eye className="w-4 h-4 mr-1" /> {done ? 'Rivedi e reinvia' : 'Anteprima e invia'}
              </Button>
            </div>
            <p className="mt-2 text-xs text-slate-400 line-clamp-2"><span className="text-slate-300">{tpl.subject}</span> — {stripHtml(tpl.body)}</p>
          </div>
        );
      })}
      {compose && (
        <EmailComposeDialog open={!!compose} onClose={() => setCompose(null)} api={api} lead={lead} template={compose.template} showToast={showToast} onSent={onChanged} />
      )}
      <EmailTemplatesDialog open={manage} onClose={() => setManage(false)} api={api} showToast={showToast} onChanged={load} />
    </div>
  );
};
